import { hideModalForADay } from '../../assets/js/modules/authentication';
import './modal.scss';

(($) => {
  const $modal = $('#modal');
  const $openButton = $('#openModal');

  $openButton.click(function () {
    openModal();
  });

  $(window).click(function (event) {
    if (event.target === $modal[0]) {
      $modal.css('display', 'none');
    }
  });

})(jQuery);

export function closeModal(modalId, hideForADay = true) {
	const modal = document.getElementById(modalId);
	if (modal) {
		modal.style.display = 'none';
    const modalOverlay = document.getElementById(`modal--overlay-${modalId}`);
		modalOverlay.style.display = 'none';
		if (hideForADay) {
			hideModalForADay();
		}
	}
}

export function openModal(modalId) {
	const modal = document.getElementById(modalId);
	if (modal) {
		modal.style.display = 'block';
    const modalOverlay = document.getElementById(`modal--overlay-${modalId}`);
		modalOverlay.style.display = 'block';
	}
}
